define('messages',['controller', 'socket', 'button-disabler', 'tooltip-notifier', 'lib/select2_locale_de_informal'],
function(controller, socket, buttonDisabler, tooltipNotifier) {
	function scrollToBottom() {
		var elem = $('body')[0];
		window.scrollTo(0, elem.scrollHeight);
	}

	/*
	 * Update number of unread messages in headers profile section
	 */ 
	socket.on('messages', function() {
		$.get('/account/get_new_message_count', function(data) {
			if(data > 0) {
				$('.message-count').parent().addClass('unread');
				$('.message-count').html(data);
			} else {
				$('.message-count').parent().removeClass('unread');
				$('.message-count').html(data);
			}
		});
	});

	function onLoadMoreClicked() {
		var button = $(this);
		buttonDisabler.disable(button);
		$.ajax({
			url: '/messages/' + button.data('conversation-id') + '/since',
			type: 'GET',
			dataType: 'json',
			data: {
				message_id: button.data('last-message-id')
			}
		}).done(function (data) {
			if (data.more_available) {
				buttonDisabler.enable(button);
				button.data('last-message-id', data.last_message_id)
			} else {
				button.remove();
			}

			$('#conversation').append(data.html);
		}).fail(function(xhr) {
			buttonDisabler.enable(button);
			tooltipNotifier.showError(button, 'Beim Nachladen der Nachrichten ist ein Fehler aufgetreten. Bitte versuche es erneut.', xhr);
		});
	}

	/*
	 * view action page
	 */
	controller.on('messages/view', function() {
		$('.load-more-messages-button').click(onLoadMoreClicked);
	});
	
	function initSelection(element, callback) {
        var elementText = $(element).attr('data-init-text');
        callback({"text":elementText,"id":elementText});
	}
	
	/*
	 * send action page
	 */
	controller.on('messages/send-select', function() {
		$('.recipient-input').select2({
			minimumInputLength: 1,
			ajax: {
				url: '/users/get_users_for_select2',
				data: function(term, page) {
					return {query: term};
				},
				dataType: 'json',
				quietMillis: 50,
				results: function(data, page, query) {
					return {results: data};
				}
			},
			width: '100%',
			language: 'de_informal',
			initSelection: initSelection
		});
	});
});

